import React, { useContext } from 'react';
import { isFunction } from 'lodash';
import { Icon } from 'ui';
import { OwnerContext } from './OwnerContext';

const OwnershipOption = ({ children, onClick, icon }) => {
  const owner = useContext(OwnerContext);
  return (
    <li>
      <button
        type="button"
        className="u-resetBtn w-240 ta-l p-2-8"
        onClick={() => onClick(owner.directOwnership)}
      >
        <Icon name={icon} className="mr-8" />
        {isFunction(children) ? children(owner) : children}
      </button>
    </li>
  );
};

export default OwnershipOption;
